
    (function () {
      var productsTooltip = null;
      var productsTooltipTarget = null;

      function getProductsTooltip() {
        if (
          productsTooltip &&
          document.body.contains(productsTooltip)
        ) {
          return productsTooltip;
        }

        productsTooltip = document.createElement('div');
        productsTooltip.className =
          'risenty-products-title-tooltip';
        productsTooltip.setAttribute('role', 'tooltip');
        productsTooltip.setAttribute(
          'data-risenty-products-tooltip',
          'true'
        );

        document.body.appendChild(productsTooltip);

        return productsTooltip;
      }

      function isProductTitleTruncated(titleElement) {
        if (!titleElement) {
          return false;
        }

        return (
          titleElement.scrollWidth >
          titleElement.clientWidth + 1
        );
      }

      function positionProductsTooltip(
        titleElement,
        tooltip
      ) {
        var rect = titleElement.getBoundingClientRect();
        var tooltipRect = tooltip.getBoundingClientRect();
        var viewportWidth = document.documentElement.clientWidth;
        var viewportHeight = document.documentElement.clientHeight;
        var gap = 8;
        var edge = 12;

        var left = rect.left;
        var top = rect.top - tooltipRect.height - gap;

        if (left + tooltipRect.width > viewportWidth - edge) {
          left = viewportWidth - tooltipRect.width - edge;
        }

        if (left < edge) {
          left = edge;
        }

        if (top < edge) {
          top = rect.bottom + gap;
        }

        if (top + tooltipRect.height > viewportHeight - edge) {
          top = Math.max(
            edge,
            viewportHeight - tooltipRect.height - edge
          );
        }

        tooltip.style.left = Math.round(left) + 'px';
        tooltip.style.top = Math.round(top) + 'px';
      }

      function showProductsTooltip(tab) {
        var titleElement = tab
          ? tab.querySelector(
              '.risenty-products-nav__title'
            )
          : null;

        if (!isProductTitleTruncated(titleElement)) {
          hideProductsTooltip();
          return;
        }

        var tooltip = getProductsTooltip();
        var fullTitle =
          titleElement.getAttribute(
            'data-risenty-full-title'
          ) || titleElement.textContent.trim();

        productsTooltipTarget = titleElement;
        tooltip.textContent = fullTitle;
        tooltip.classList.add('is-visible');

        requestAnimationFrame(function () {
          if (productsTooltipTarget === titleElement) {
            positionProductsTooltip(
              titleElement,
              tooltip
            );
          }
        });
      }

      function hideProductsTooltip() {
        productsTooltipTarget = null;

        if (productsTooltip) {
          productsTooltip.classList.remove('is-visible');
        }
      }

      function hydrateProductsPanel(root, index) {
        var targetPanel = null;

        root
          .querySelectorAll(
            '[data-risenty-product-panel]'
          )
          .forEach(function (panel) {
            if (
              panel.getAttribute(
                'data-risenty-product-panel'
              ) === index
            ) {
              targetPanel = panel;
            }
          });

        if (!targetPanel) {
          return;
        }

        var grid = targetPanel.querySelector(
          '[data-risenty-product-grid]'
        );

        if (
          !grid ||
          grid.getAttribute(
            'data-risenty-panel-loaded'
          ) === 'true'
        ) {
          return;
        }

        var template = grid.querySelector(
          'template[data-risenty-product-card-template]'
        );

        if (template && template.content) {
          grid.insertBefore(
            template.content.cloneNode(true),
            template
          );

          template.remove();
        }

        grid.setAttribute(
          'data-risenty-panel-loaded',
          'true'
        );

        window.requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
        });
      }

      function initializeProductsTabs(scope) {
        var roots =
          scope.querySelectorAll(
            '#risenty-products-mega'
          );

        roots.forEach(function (root) {
          if (
            root.getAttribute(
              'data-risenty-products-tabs-ready'
            ) === 'true'
          ) {
            return;
          }

          root.setAttribute(
            'data-risenty-products-tabs-ready',
            'true'
          );

          root.addEventListener(
            'mouseover',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-product-tab]'
              );

              if (!tab || !root.contains(tab)) {
                return;
              }

              var previous = event.relatedTarget;

              if (previous && tab.contains(previous)) {
                return;
              }

              hydrateProductsPanel(
                root,
                tab.getAttribute(
                  'data-risenty-product-tab'
                )
              );

              showProductsTooltip(tab);
            }
          );

          root.addEventListener(
            'mouseout',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-product-tab]'
              );

              if (!tab || !root.contains(tab)) {
                return;
              }

              var next = event.relatedTarget;

              if (next && tab.contains(next)) {
                return;
              }

              hideProductsTooltip();
            }
          );

          root.addEventListener(
            'focusin',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-product-tab]'
              );

              if (tab && root.contains(tab)) {
                showProductsTooltip(tab);
              }
            }
          );

          root.addEventListener(
            'focusout',
            function (event) {
              var next = event.relatedTarget;

              if (!next || !root.contains(next)) {
                hideProductsTooltip();
                return;
              }

              if (
                !next.closest(
                  '[data-risenty-product-tab]'
                )
              ) {
                hideProductsTooltip();
              }
            }
          );

          var productsNav = root.querySelector(
            '.risenty-products-nav'
          );

          if (productsNav) {
            productsNav.addEventListener(
              'scroll',
              hideProductsTooltip,
              { passive: true }
            );
          }

          root.addEventListener(
            'click',
            function (event) {
              var tab =
                event.target.closest(
                  '[data-risenty-product-tab]'
                );

              if (
                !tab ||
                !root.contains(tab)
              ) {
                return;
              }

              var index =
                tab.getAttribute(
                  'data-risenty-product-tab'
                );

              hydrateProductsPanel(
                root,
                index
              );

              root
                .querySelectorAll(
                  '[data-risenty-product-tab]'
                )
                .forEach(
                  function (currentTab) {
                    var active =
                      currentTab.getAttribute(
                        'data-risenty-product-tab'
                      ) === index;

                    currentTab.classList.toggle(
                      'is-active',
                      active
                    );

                    currentTab.setAttribute(
                      'aria-selected',
                      active
                        ? 'true'
                        : 'false'
                    );
                  }
                );

              root
                .querySelectorAll(
                  '[data-risenty-product-panel]'
                )
                .forEach(
                  function (panel) {
                    panel.hidden =
                      panel.getAttribute(
                        'data-risenty-product-panel'
                      ) !== index;
                  }
                );
            }
          );
        });
      }

      function startProductsTabs() {
        initializeProductsTabs(
          document
        );
      }

      if (
        document.readyState ===
        'loading'
      ) {
        document.addEventListener(
          'DOMContentLoaded',
          startProductsTabs
        );
      } else {
        startProductsTabs();
      }

      document.addEventListener(
        'shopify:section:load',
        function (event) {
          hideProductsTooltip();
          initializeProductsTabs(
            event.target
          );
        }
      );

      window.addEventListener(
        'resize',
        hideProductsTooltip,
        { passive: true }
      );

      window.addEventListener(
        'scroll',
        hideProductsTooltip,
        { passive: true }
      );
    })();
  
;

    (function () {
      var productsTooltip = null;
      var productsTooltipTarget = null;

      function getProductsTooltip() {
        if (
          productsTooltip &&
          document.body.contains(productsTooltip)
        ) {
          return productsTooltip;
        }

        productsTooltip = document.createElement('div');
        productsTooltip.className =
          'risenty-products-title-tooltip';
        productsTooltip.setAttribute('role', 'tooltip');
        productsTooltip.setAttribute(
          'data-risenty-products-tooltip',
          'true'
        );

        document.body.appendChild(productsTooltip);

        return productsTooltip;
      }

      function isProductTitleTruncated(titleElement) {
        if (!titleElement) {
          return false;
        }

        return (
          titleElement.scrollWidth >
          titleElement.clientWidth + 1
        );
      }

      function positionProductsTooltip(
        titleElement,
        tooltip
      ) {
        var rect = titleElement.getBoundingClientRect();
        var tooltipRect = tooltip.getBoundingClientRect();
        var viewportWidth = document.documentElement.clientWidth;
        var viewportHeight = document.documentElement.clientHeight;
        var gap = 8;
        var edge = 12;

        var left = rect.left;
        var top = rect.top - tooltipRect.height - gap;

        if (left + tooltipRect.width > viewportWidth - edge) {
          left = viewportWidth - tooltipRect.width - edge;
        }

        if (left < edge) {
          left = edge;
        }

        if (top < edge) {
          top = rect.bottom + gap;
        }

        if (top + tooltipRect.height > viewportHeight - edge) {
          top = Math.max(
            edge,
            viewportHeight - tooltipRect.height - edge
          );
        }

        tooltip.style.left = Math.round(left) + 'px';
        tooltip.style.top = Math.round(top) + 'px';
      }

      function showProductsTooltip(tab) {
        var titleElement = tab
          ? tab.querySelector(
              '.risenty-products-nav__title'
            )
          : null;

        if (!isProductTitleTruncated(titleElement)) {
          hideProductsTooltip();
          return;
        }

        var tooltip = getProductsTooltip();
        var fullTitle =
          titleElement.getAttribute(
            'data-risenty-full-title'
          ) || titleElement.textContent.trim();

        productsTooltipTarget = titleElement;
        tooltip.textContent = fullTitle;
        tooltip.classList.add('is-visible');

        requestAnimationFrame(function () {
          if (productsTooltipTarget === titleElement) {
            positionProductsTooltip(
              titleElement,
              tooltip
            );
          }
        });
      }

      function hideProductsTooltip() {
        productsTooltipTarget = null;

        if (productsTooltip) {
          productsTooltip.classList.remove('is-visible');
        }
      }

      function hydrateProductsPanel(root, index) {
        var targetPanel = null;

        root
          .querySelectorAll(
            '[data-risenty-product-panel]'
          )
          .forEach(function (panel) {
            if (
              panel.getAttribute(
                'data-risenty-product-panel'
              ) === index
            ) {
              targetPanel = panel;
            }
          });

        if (!targetPanel) {
          return;
        }

        var grid = targetPanel.querySelector(
          '[data-risenty-product-grid]'
        );

        if (
          !grid ||
          grid.getAttribute(
            'data-risenty-panel-loaded'
          ) === 'true'
        ) {
          return;
        }

        var template = grid.querySelector(
          'template[data-risenty-product-card-template]'
        );

        if (template && template.content) {
          grid.insertBefore(
            template.content.cloneNode(true),
            template
          );

          template.remove();
        }

        grid.setAttribute(
          'data-risenty-panel-loaded',
          'true'
        );

        window.requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
        });
      }

      function initializeProductsTabs(scope) {
        var roots =
          scope.querySelectorAll(
            '#risenty-fandoms-mega'
          );

        roots.forEach(function (root) {
          if (
            root.getAttribute(
              'data-risenty-products-tabs-ready'
            ) === 'true'
          ) {
            return;
          }

          root.setAttribute(
            'data-risenty-products-tabs-ready',
            'true'
          );

          root.addEventListener(
            'mouseover',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-product-tab]'
              );

              if (!tab || !root.contains(tab)) {
                return;
              }

              var previous = event.relatedTarget;

              if (previous && tab.contains(previous)) {
                return;
              }

              hydrateProductsPanel(
                root,
                tab.getAttribute(
                  'data-risenty-product-tab'
                )
              );

              showProductsTooltip(tab);
            }
          );

          root.addEventListener(
            'mouseout',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-product-tab]'
              );

              if (!tab || !root.contains(tab)) {
                return;
              }

              var next = event.relatedTarget;

              if (next && tab.contains(next)) {
                return;
              }

              hideProductsTooltip();
            }
          );

          root.addEventListener(
            'focusin',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-product-tab]'
              );

              if (tab && root.contains(tab)) {
                showProductsTooltip(tab);
              }
            }
          );

          root.addEventListener(
            'focusout',
            function (event) {
              var next = event.relatedTarget;

              if (!next || !root.contains(next)) {
                hideProductsTooltip();
                return;
              }

              if (
                !next.closest(
                  '[data-risenty-product-tab]'
                )
              ) {
                hideProductsTooltip();
              }
            }
          );

          var productsNav = root.querySelector(
            '.risenty-products-nav'
          );

          if (productsNav) {
            productsNav.addEventListener(
              'scroll',
              hideProductsTooltip,
              { passive: true }
            );
          }

          root.addEventListener(
            'click',
            function (event) {
              var tab =
                event.target.closest(
                  '[data-risenty-product-tab]'
                );

              if (
                !tab ||
                !root.contains(tab)
              ) {
                return;
              }

              var index =
                tab.getAttribute(
                  'data-risenty-product-tab'
                );

              hydrateProductsPanel(
                root,
                index
              );

              root
                .querySelectorAll(
                  '[data-risenty-product-tab]'
                )
                .forEach(
                  function (currentTab) {
                    var active =
                      currentTab.getAttribute(
                        'data-risenty-product-tab'
                      ) === index;

                    currentTab.classList.toggle(
                      'is-active',
                      active
                    );

                    currentTab.setAttribute(
                      'aria-selected',
                      active
                        ? 'true'
                        : 'false'
                    );
                  }
                );

              root
                .querySelectorAll(
                  '[data-risenty-product-panel]'
                )
                .forEach(
                  function (panel) {
                    panel.hidden =
                      panel.getAttribute(
                        'data-risenty-product-panel'
                      ) !== index;
                  }
                );
            }
          );
        });
      }

      function startProductsTabs() {
        initializeProductsTabs(
          document
        );
      }

      if (
        document.readyState ===
        'loading'
      ) {
        document.addEventListener(
          'DOMContentLoaded',
          startProductsTabs
        );
      } else {
        startProductsTabs();
      }

      document.addEventListener(
        'shopify:section:load',
        function (event) {
          hideProductsTooltip();
          initializeProductsTabs(
            event.target
          );
        }
      );

      window.addEventListener(
        'resize',
        hideProductsTooltip,
        { passive: true }
      );

      window.addEventListener(
        'scroll',
        hideProductsTooltip,
        { passive: true }
      );
    })();
  
;

    (function () {
      var dealsTooltip = null;
      var dealsTooltipTarget = null;

      function getDealsTooltip() {
        if (
          dealsTooltip &&
          document.body.contains(dealsTooltip)
        ) {
          return dealsTooltip;
        }

        dealsTooltip = document.createElement('div');
        dealsTooltip.className =
          'risenty-deals-title-tooltip';
        dealsTooltip.setAttribute('role', 'tooltip');
        dealsTooltip.setAttribute(
          'data-risenty-deals-tooltip',
          'true'
        );

        document.body.appendChild(dealsTooltip);

        return dealsTooltip;
      }

      function isProductTitleTruncated(titleElement) {
        if (!titleElement) {
          return false;
        }

        return (
          titleElement.scrollWidth >
          titleElement.clientWidth + 1
        );
      }

      function positionDealsTooltip(
        titleElement,
        tooltip
      ) {
        var rect = titleElement.getBoundingClientRect();
        var tooltipRect = tooltip.getBoundingClientRect();
        var viewportWidth = document.documentElement.clientWidth;
        var viewportHeight = document.documentElement.clientHeight;
        var gap = 8;
        var edge = 12;

        var left = rect.left;
        var top = rect.top - tooltipRect.height - gap;

        if (left + tooltipRect.width > viewportWidth - edge) {
          left = viewportWidth - tooltipRect.width - edge;
        }

        if (left < edge) {
          left = edge;
        }

        if (top < edge) {
          top = rect.bottom + gap;
        }

        if (top + tooltipRect.height > viewportHeight - edge) {
          top = Math.max(
            edge,
            viewportHeight - tooltipRect.height - edge
          );
        }

        tooltip.style.left = Math.round(left) + 'px';
        tooltip.style.top = Math.round(top) + 'px';
      }

      function showDealsTooltip(tab) {
        var titleElement = tab
          ? tab.querySelector(
              '.risenty-deals-nav__title'
            )
          : null;

        if (!isProductTitleTruncated(titleElement)) {
          hideDealsTooltip();
          return;
        }

        var tooltip = getDealsTooltip();
        var fullTitle =
          titleElement.getAttribute(
            'data-risenty-full-title'
          ) || titleElement.textContent.trim();

        dealsTooltipTarget = titleElement;
        tooltip.textContent = fullTitle;
        tooltip.classList.add('is-visible');

        requestAnimationFrame(function () {
          if (dealsTooltipTarget === titleElement) {
            positionDealsTooltip(
              titleElement,
              tooltip
            );
          }
        });
      }

      function hideDealsTooltip() {
        dealsTooltipTarget = null;

        if (dealsTooltip) {
          dealsTooltip.classList.remove('is-visible');
        }
      }

      function hydrateDealsPanel(root, index) {
        var targetPanel = null;

        root
          .querySelectorAll(
            '[data-risenty-deal-panel]'
          )
          .forEach(function (panel) {
            if (
              panel.getAttribute(
                'data-risenty-deal-panel'
              ) === index
            ) {
              targetPanel = panel;
            }
          });

        if (!targetPanel) {
          return;
        }

        var grid = targetPanel.querySelector(
          '[data-risenty-deal-grid]'
        );

        if (
          !grid ||
          grid.getAttribute(
            'data-risenty-panel-loaded'
          ) === 'true'
        ) {
          return;
        }

        var template = grid.querySelector(
          'template[data-risenty-deal-card-template]'
        );

        if (template && template.content) {
          grid.insertBefore(
            template.content.cloneNode(true),
            template
          );

          template.remove();
        }

        grid.setAttribute(
          'data-risenty-panel-loaded',
          'true'
        );

        window.requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
        });
      }

      function initializeDealsTabs(scope) {
        var roots =
          scope.querySelectorAll(
            '#risenty-deals-mega'
          );

        roots.forEach(function (root) {
          if (
            root.getAttribute(
              'data-risenty-deals-tabs-ready'
            ) === 'true'
          ) {
            return;
          }

          root.setAttribute(
            'data-risenty-deals-tabs-ready',
            'true'
          );

          root.addEventListener(
            'mouseover',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-deal-tab]'
              );

              if (!tab || !root.contains(tab)) {
                return;
              }

              var previous = event.relatedTarget;

              if (previous && tab.contains(previous)) {
                return;
              }

              hydrateDealsPanel(
                root,
                tab.getAttribute(
                  'data-risenty-deal-tab'
                )
              );

              showDealsTooltip(tab);
            }
          );

          root.addEventListener(
            'mouseout',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-deal-tab]'
              );

              if (!tab || !root.contains(tab)) {
                return;
              }

              var next = event.relatedTarget;

              if (next && tab.contains(next)) {
                return;
              }

              hideDealsTooltip();
            }
          );

          root.addEventListener(
            'focusin',
            function (event) {
              var tab = event.target.closest(
                '[data-risenty-deal-tab]'
              );

              if (tab && root.contains(tab)) {
                showDealsTooltip(tab);
              }
            }
          );

          root.addEventListener(
            'focusout',
            function (event) {
              var next = event.relatedTarget;

              if (!next || !root.contains(next)) {
                hideDealsTooltip();
                return;
              }

              if (
                !next.closest(
                  '[data-risenty-deal-tab]'
                )
              ) {
                hideDealsTooltip();
              }
            }
          );

          var dealsNav = root.querySelector(
            '.risenty-deals-nav'
          );

          if (dealsNav) {
            dealsNav.addEventListener(
              'scroll',
              hideDealsTooltip,
              { passive: true }
            );
          }

          root.addEventListener(
            'click',
            function (event) {
              var tab =
                event.target.closest(
                  '[data-risenty-deal-tab]'
                );

              if (
                !tab ||
                !root.contains(tab)
              ) {
                return;
              }

              var index =
                tab.getAttribute(
                  'data-risenty-deal-tab'
                );

              hydrateDealsPanel(
                root,
                index
              );

              root
                .querySelectorAll(
                  '[data-risenty-deal-tab]'
                )
                .forEach(
                  function (currentTab) {
                    var active =
                      currentTab.getAttribute(
                        'data-risenty-deal-tab'
                      ) === index;

                    currentTab.classList.toggle(
                      'is-active',
                      active
                    );

                    currentTab.setAttribute(
                      'aria-selected',
                      active
                        ? 'true'
                        : 'false'
                    );
                  }
                );

              root
                .querySelectorAll(
                  '[data-risenty-deal-panel]'
                )
                .forEach(
                  function (panel) {
                    panel.hidden =
                      panel.getAttribute(
                        'data-risenty-deal-panel'
                      ) !== index;
                  }
                );
            }
          );
        });
      }

      function startDealsTabs() {
        initializeDealsTabs(
          document
        );
      }

      if (
        document.readyState ===
        'loading'
      ) {
        document.addEventListener(
          'DOMContentLoaded',
          startDealsTabs
        );
      } else {
        startDealsTabs();
      }

      document.addEventListener(
        'shopify:section:load',
        function (event) {
          hideDealsTooltip();
          initializeDealsTabs(
            event.target
          );
        }
      );

      window.addEventListener(
        'resize',
        hideDealsTooltip,
        { passive: true }
      );

      window.addEventListener(
        'scroll',
        hideDealsTooltip,
        { passive: true }
      );
    })();
  